export default __webpack_public_path__ + "img/hbGRbewO.d5a9ea13.svg";